"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Fri Nov 02 2018
*/

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * This object represents a user customizable grid view
 *
 * @author RV
 */


var GridSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(GridSettings, _DomainObject_1$Domai);

  /**
   * Constructs GridSettings instance.
   *
   * @param id
   * @param userId id of user
   * @param parentId parent id of GridSettings
   * @param nameOfTable table name
   * @param icon identification of icon to display for this settings
   * @param name
   * @param shared true, if it is shared among all users
   * @param settings the grid settings itself - filters, sort orders, column order, ...
   */
  function GridSettings(id, parentId, userId, nameOfTable, icon, name, shared, settings) {
    var _this;

    _classCallCheck(this, GridSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridSettings).call(this));
    _this.id = id;
    _this.parentId = parentId;
    _this.userId = userId;
    _this.nameOfTable = nameOfTable;
    _this.icon = icon;
    _this.name = name;
    _this.shared = shared;
    _this.settings = settings;
    return _this;
  }

  return GridSettings;
}(DomainObject_1.DomainObject);

exports.GridSettings = GridSettings;